export default "__VITE_ASSET__BxdDxaAe__"